import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ButtonGroup, ToggleButton } from "react-bootstrap";
import axios from "axios";
import { toaster } from "../../utils/utils";
import apiConstants from "../../constans/apiConstants";
import DataTable from "../../components/Table/index";
import {
  getTpaPoposal,
  tpaPoposal,
  tpaUpdatePoposal,
  tpaDeletePoposal,
} from "../../store/actions/tpaActions";
import { getApiStatus } from "../../store/actions/switchAPIAction";
import { getProductList } from "../../store/actions/productConfigActions";
import MobilePopUp from "../../components/MobilePopUp/MobilePopUp";
import { datata } from "./data";
import FreezeDates from "./FreezeDates";

const TPA_MedicalScheduling = (props) => {
  const dispatch = useDispatch();
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const productList = useSelector(
    (state) => state?.productTypeData?.productList
  );
  const statusPanON = useSelector(
    (state) => state?.switchApiReducer?.switchApiData?.waiveOffMedicalsPanIndia
  );
  // console.log("statusPanON", statusPanON);

  const [showEditModal, setshowEditModal] = useState(false);
  const [mainData, setMainData] = useState({
    id: "",
    waiveOffOption: "Waive off Medical Requirement",
    waivedRadio: "",
    sourceValue: "",
    channelValue: "",
    subPartnerValue: "",
    partnerValue: "",
    updateWaiveOffOption: "",
    updateWaivedRadio: "",
    productName: "",
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
  });
  const [tpaData, setTPAData] = useState("");
  const [data, setData] = useState();
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [showCancelBtn, setShowCancelBtn] = useState(false);

  const options = [
    {
      id: 1,
      key: "WAIVE_OFF_MEDICALS",
      text: "Waive off Medical Requirement",
      shortText: "Waive Medical Req.",
    },
    {
      id: 2,
      key: "ONLY_TPA",
      text: "Waive off Triggering TPA Portal Link for Medicals",
      shortText: "Waive off Triggering TPA...",
    },
    {
      id: 3,
      key: "BYPASS_DEDUPE",
      text: "Waive off Rule Run on Medical Report Validity for 6-Months/12-Months",
      shortText: "Waive off Rule Run...",
    },
  ];
  const radios = [
    { id: 1, text: "Proposer" },
    { id: 2, text: "Insured" },
    { id: 3, text: "Both" },
  ];

  useEffect(() => {
    // Fetch status api
    dispatch(getApiStatus());
  }, [dispatch]);

  useEffect(() => {
    // Fetch the API data
    dispatch(
      getTpaPoposal((response) => {
        setTPAData(
          response.body.map((item) => ({
            id: item.id,
            channelName:
              item.channelName === "ALL_VALUES" ? "All" : item.channelName,
            subChannelName:
              item.subChannelName === "ALL_VALUES"
                ? "All"
                : item.subChannelName,
            cabPartnerName:
              item.cabPartnerName === "ALL_VALUES"
                ? "All"
                : item.cabPartnerName,
            productName: item.productName,
            proposalCreationStartDate: item.proposalCreationStartDate,
            proposalCreationEndDate: item.proposalCreationEndDate,
            waivedOffBy: item.waivedOffBy,
            audit: `Created On: ${formatDate(
              item.audit.createdOn
            )}, Updated On: ${formatDate(item.audit.updatedOn)}`,
            tpaWaiveOffType: getShortenedWaiveOffType(item.tpaWaiveOffType),
            tpaWaiveOffForProposer: item.tpaWaiveOffForProposer,
            tpaWaiveOffForInsured: item.tpaWaiveOffForInsured,
            tpaWaiveOffForBoth: item.tpaWaiveOffForBoth,
          }))
        );
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getAllItem(); // get source/ channel/ partner list
  }, []);

  useEffect(() => {
    dispatch(getProductList()); // get product list
  }, []);

  useEffect(() => {
    setTPAData(tpaData); // tpa data setting after delete
  }, [tpaData]);
  const getShortenedWaiveOffType = (type) => {
    switch (type) {
      case "WAIVE_OFF_MEDICALS":
        return "Waive Medical Req.";
      case "ONLY_TPA":
        return "Waive off Triggering TPA...";
      case "BYPASS_DEDUPE":
        return "Waive off Rule Run...";
      default:
        return "";
    }
  };
  // souce / channel/ partner list
  const getAllItem = () => {
    const param = `partnerName=${mainData.partnerValue}&subChannel=${mainData.subPartnerValue}&channel=${mainData.channelValue}&sources=${mainData.sourceValue}`;
    const queryParam = param ? param : "partnerName&subChannel&channel&sources";
    axios
      .get(
        `${
          apiConstants().PROPOSEL_API_URL
        }api/v1/proposal/instaVerify/instaRuleSheet?${queryParam}
      `,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("token"),
          },
        }
      )
      .then((res) => {
        dispatch({ type: "LOADER_FALSE" });
        if (res && res.data) {
          setData(res?.data?.body);
          // toaster("success", res.data.message);
        }
      })
      .catch((err) => {
        dispatch({ type: "LOADER_FALSE" });
        if (err && err.data) {
          // toaster("error", err.data.message);
        }
      });
  };

  const getUniqueListBy = (array, key) => {
    return [
      ...new Map(
        array
          ?.filter(
            (item) =>
              item[key] &&
              item[key].toString().trim() !== "" &&
              item[key] !== "0"
          )
          .map((item) => [item[key].trim().toLowerCase(), item])
      ).values(),
    ];
  };

  const productName = getUniqueListBy(productList, "productName").map(
    (item) => ({
      id: item.productId,
      text: item.productName,
    })
  );

  const sourceList = getUniqueListBy(data, "sources")?.map((item) => ({
    id: item.id,
    text: item.sources,
  }));

  const filteredChannelList = data?.filter(
    (item) => item.sources === mainData.sourceValue
  );
  const channelList = getUniqueListBy(filteredChannelList, "channel")?.map(
    (item) => ({
      id: item.id,
      text: item.channel,
    })
  );

  const filteredsubPartner = data?.filter(
    (item) => item.channel === mainData.channelValue
  );
  const subPartnerList = getUniqueListBy(filteredsubPartner, "subChannel")?.map(
    (item) => ({
      id: item.id,
      text: item.subChannel,
    })
  );

  const filteredPartner = data?.filter(
    (item) => item.subChannel === mainData.subPartnerValue
  );
  const partnerList = getUniqueListBy(filteredPartner, "partnerName")?.map(
    (item) => ({
      id: item.id,
      text: item.partnerName,
    })
  );

  // console.log('partnerList',channelList,subPartnerList,partnerList)

  // handleChange
  const handleChange = (event, detail) => {
    const { value } = event.target;

    setMainData((prevData) => {
      let updatedData = { ...prevData, [detail]: value };

      if (value === "ALL_VALUES") {
        if (detail === "sourceValue") {
          updatedData.channelValue = "ALL_VALUES";
          updatedData.subPartnerValue = "ALL_VALUES";
          updatedData.partnerValue = "ALL_VALUES";
        } else if (detail === "channelValue") {
          updatedData.subPartnerValue = "ALL_VALUES";
          updatedData.partnerValue = "ALL_VALUES";
        } else if (detail === "subPartnerValue") {
          updatedData.partnerValue = "ALL_VALUES";
        }
      }

      return updatedData;
    });
  };

  // formate date and time

  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length < 6) return "-";
    const [year, month, day, hour, minute, second] = dateArray;
    const formattedDate = `${String(day).padStart(2, "0")}-${String(
      month
    ).padStart(2, "0")}-${year}`;
    const formattedTime = `${hour}:${String(minute).padStart(2, "0")}:${String(
      second
    ).padStart(2, "0")}`;
    return `${formattedDate} ${formattedTime}`;
  };

  const formatDateTime = (date, time) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return `${formattedDate}`;
  };

  const formatStartDate = (dateTime) => {
    if (!dateTime) return { date: "", time: "" };

    const [datePart, timePart] = dateTime.split(" ");
    return {
      date: datePart.replace(/-/g, "/"),
      time: timePart.substring(0, 5),
    };
  };

  // handle change

  const handleDateChange = (obj, detail) => {
    const formattedStartDate = formatDateTime(obj?.freezeStartDate);
    const formattedEndDate = formatDateTime(obj?.freezeEndDate);

    setMainData((prevData) => {
      let updatedData = {
        ...prevData,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        startTime: `${obj.freezeStartTime}:00`,
        endTime: `${obj.freezeEndTime}:00`,
      };
      return updatedData;
    });
  };

  // final form submit
  const finalSubmit = () => {
    let tpaProposer;
    let tpaInsured;
    let tpaBoth;
    let waivedType;
    if (mainData.waivedRadio === "Proposer") {
      tpaProposer = true;
      tpaInsured = false;
      tpaBoth = false;
    } else if (mainData.waivedRadio === "Insured") {
      tpaProposer = false;
      tpaInsured = true;
      tpaBoth = false;
    } else if (mainData.waivedRadio === "Both") {
      tpaProposer = false;
      tpaInsured = false;
      tpaBoth = true;
    }

    let result = {};
    let selectedOption = options.find(
      (option) => option.text === mainData.waiveOffOption
    );
    if (selectedOption) {
      result.key = selectedOption.key;
    }
    let data;
    if (mainData.waiveOffOption === "Waive off Medical Requirement") {
      data = {
        waivedOffBy: userDetails?.user?.code,
        tpaWaiveOffType: result.key,
        tpaWaiveOffForProposer: tpaProposer,
        tpaWaiveOffForInsured: tpaInsured,
        tpaWaiveOffForBoth: tpaBoth,
        productName: mainData.productName,
        channelName:
          mainData.channelValue === "" ? "All" : mainData.channelValue,
        subChannelName:
          mainData.subPartnerValue === "" ? "All" : mainData.subPartnerValue,
        cabPartnerName:
          mainData.partnerValue === "" ? "All" : mainData.partnerValue,
        proposalCreationStartDate:
          mainData.startDate + " " + mainData.startTime + ".00",
        proposalCreationEndDate:
          mainData.endDate + " " + mainData.endTime + ".00",
      };
    } else {
      data = {
        waivedOffBy: userDetails?.user?.code,
        tpaWaiveOffType: result.key,
        tpaWaiveOffForProposer: tpaProposer,
        tpaWaiveOffForInsured: tpaInsured,
        tpaWaiveOffForBoth: tpaBoth,
        // productName: mainData.productName,
        channelName:
          mainData.channelValue === "" ? "All" : mainData.channelValue,
        subChannelName:
          mainData.subPartnerValue === "" ? "All" : mainData.subPartnerValue,
        cabPartnerName:
          mainData.partnerValue === "" ? "All" : mainData.partnerValue,
        // proposalCreationStartDate:
        //   mainData.startDate + " " + mainData.startTime + ".00",
        // proposalCreationEndDate:
        //   mainData.endDate + " " + mainData.endTime + ".00",
      };
    }

    dispatch(
      tpaPoposal(data, (res) => {
        if (
          res.status === "OK" ||
          res.status === "FOUND" ||
          res.status === "CREATED"
        ) {
          setTPAData(
            res.body.map((item) => ({
              id: item.id,
              channelName:
                item.channelName === "ALL_VALUES" ? "All" : item.channelName,
              subChannelName:
                item.subChannelName === "ALL_VALUES"
                  ? "All"
                  : item.subChannelName,
              cabPartnerName:
                item.cabPartnerName === "ALL_VALUES"
                  ? "All"
                  : item.cabPartnerName,
              productName: item.productName,
              proposalCreationStartDate: item.proposalCreationStartDate,
              proposalCreationEndDate: item.proposalCreationEndDate,
              waivedOffBy: item.waivedOffBy,
              audit: formatDate(item.audit.createdOn),
              tpaWaiveOffType: getShortenedWaiveOffType(item.tpaWaiveOffType),
              tpaWaiveOffForProposer: item.tpaWaiveOffForProposer,
              tpaWaiveOffForInsured: item.tpaWaiveOffForInsured,
              tpaWaiveOffForBoth: item.tpaWaiveOffForBoth,
            }))
          );
        } else {
          setMainData({
            waiveOffOption: "Waive off Medical Requirement",
            waivedRadio: "",
            sourceValue: "",
            channelValue: "",
            subPartnerValue: "",
            partnerValue: "",
            updateWaiveOffOption: "",
            updateWaivedRadio: "",
            productName: "",
            startDate: "",
            endDate: "",
            startTime: "",
            endTime: "",
          });

          // console.log('manidata',mainData)
        }
      })
    );
  };

  // update form values

  const handleUpdateChange = (item) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setShowCancelBtn(true);
    // waiveOffOption
    let result = {};
    let selectedOption = options.find(
      (option) => option.shortText === item.tpaWaiveOffType
    );
    if (selectedOption) {
      result.text = selectedOption.text;
    }

    // waivedRadio
    let waivedRadioVal;
    if (item.tpaWaiveOffForBoth === true) {
      waivedRadioVal = "Both";
    } else if (item.tpaWaiveOffForInsured === true) {
      waivedRadioVal = "Insured";
    } else if (item.tpaWaiveOffForProposer === true) {
      waivedRadioVal = "Proposer";
    }

    // start, end time

    const tpaStart = formatStartDate(item.proposalCreationStartDate);
    const tpaEnd = formatStartDate(item.proposalCreationEndDate);

    setMainData({
      id: item.id,
      waiveOffOption: result.text,
      waivedRadio: waivedRadioVal,
      sourceValue: "MSP",
      channelValue: item.subChannelName,
      subPartnerValue: "",
      partnerValue: item.cabPartnerName,
      productName: item.productName,
      startDate: tpaStart.date,
      startTime: tpaStart.time,
      endDate: tpaEnd.date,
      endTime: tpaEnd.time,
    });
  };

  // console.log("setMani", mainData);

  const updateTPAData = () => {
    const {
      id,
      waiveOffOption,
      waivedRadio,
      sourceValue,
      channelValue,
      subPartnerValue,
      partnerValue,
      productName,
      startDate,
      endDate,
    } = mainData;

    // console.log(">>", mainData);

    // waiveOffOption
    let result = {};
    let selectedOption = options.find(
      (option) => option.text === waiveOffOption
    );
    if (selectedOption) {
      result.key = selectedOption.key;
    }

    // waivedRadio
    let tpaProposer;
    let tpaInsured;
    let tpaBoth;
    if (waivedRadio === "Proposer") {
      tpaProposer = true;
      tpaInsured = false;
      tpaBoth = false;
    } else if (waivedRadio === "Insured") {
      tpaProposer = false;
      tpaInsured = true;
      tpaBoth = false;
    } else if (waivedRadio === "Both") {
      tpaProposer = false;
      tpaInsured = false;
      tpaBoth = true;
    }

    let data;
    if (mainData.waiveOffOption === "Waive off Medical Requirement") {
      data = {
        id: id,
        waivedOffBy: userDetails?.user?.code,
        tpaWaiveOffType: result.key,
        productName: productName,
        tpaWaiveOffForProposer: tpaProposer,
        tpaWaiveOffForInsured: tpaInsured,
        tpaWaiveOffForBoth: tpaBoth,
        channelName: mainData.channelValue,
        subChannelName: mainData.subPartnerValue,
        cabPartnerName: mainData.partnerValue,
        proposalCreationStartDate:
          mainData.startDate + " " + mainData.startTime + ".00",
        proposalCreationEndDate:
          mainData.endDate + " " + mainData.endTime + ".00",
      };
    } else {
      data = {
        id: id,
        waivedOffBy: userDetails?.user?.code,
        tpaWaiveOffType: result.key,
        // productName: productName,
        tpaWaiveOffForProposer: tpaProposer,
        tpaWaiveOffForInsured: tpaInsured,
        tpaWaiveOffForBoth: tpaBoth,
        channelName: mainData.channelValue,
        subChannelName: mainData.subPartnerValue,
        cabPartnerName: mainData.partnerValue,
        // proposalCreationStartDate:
        //   mainData.startDate + " " + mainData.startTime + ".00",
        // proposalCreationEndDate:
        //   mainData.endDate + " " + mainData.endTime + ".00",
      };
    }

    dispatch(
      tpaUpdatePoposal(data, (res) => {
        if (res.status === "OK" || res.status === "FOUND") {
          setTPAData(
            res.body.map((item) => ({
              id: item.id,
              channelName:
                item.channelName === "ALL_VALUES" ? "All" : item.channelName,
              subChannelName:
                item.subChannelName === "ALL_VALUES"
                  ? "All"
                  : item.subChannelName,
              cabPartnerName:
                item.cabPartnerName === "ALL_VALUES"
                  ? "All"
                  : item.cabPartnerName,
              productName: item.productName,
              proposalCreationStartDate: item.proposalCreationStartDate,
              proposalCreationEndDate: item.proposalCreationEndDate,
              waivedOffBy: item.waivedOffBy,
              audit: formatDate(item.audit.createdOn),
              tpaWaiveOffType: getShortenedWaiveOffType(item.tpaWaiveOffType),
              tpaWaiveOffForProposer: item.tpaWaiveOffForProposer,
              tpaWaiveOffForInsured: item.tpaWaiveOffForInsured,
              tpaWaiveOffForBoth: item.tpaWaiveOffForBoth,
            }))
          );
        }
      })
    );
  };

  // delete values
  const deleteData = async (modalData) => {
    try {
      // Dispatch the freezeDateAction and wait for it to complete
      await dispatch(
        tpaDeletePoposal(modalData, (res) => {
          setshowDeleteModal(false);
          if (res.data.status === "OK") {
            setTPAData(
              res.data.body.map((item) => ({
                id: item.id,
                channelName:
                  item.channelName === "ALL_VALUES" ? "All" : item.channelName,
                subChannelName:
                  item.subChannelName === "ALL_VALUES"
                    ? "All"
                    : item.subChannelName,
                cabPartnerName:
                  item.cabPartnerName === "ALL_VALUES"
                    ? "All"
                    : item.cabPartnerName,
                productName: item.productName,
                proposalCreationStartDate: item.proposalCreationStartDate,
                proposalCreationEndDate: item.proposalCreationEndDate,
                waivedOffBy: item.waivedOffBy,
                audit: formatDate(item.audit.createdOn),
                tpaWaiveOffType: getShortenedWaiveOffType(item.tpaWaiveOffType),
                tpaWaiveOffForProposer: item.tpaWaiveOffForProposer,
                tpaWaiveOffForInsured: item.tpaWaiveOffForInsured,
                tpaWaiveOffForBoth: item.tpaWaiveOffForBoth,
              }))
            );
          }
        })
      );
    } catch (error) {
      console.error("Error during saving:", error);
    }
    cancelHandler();
  };

  const cancelHandler = () => {
    setShowCancelBtn(false);
    setMainData({
      waiveOffOption: "",
      waivedRadio: "",
      sourceValue: "",
      channelValue: "",
      subPartnerValue: "",
      partnerValue: "",
      updateWaiveOffOption: "",
      updateWaivedRadio: "",
      productName: "",
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
    });
  };

  const getFormattedTpaData = (data = []) => {
    if (!Array.isArray(data)) return [];
    return data.map((item) => {
      const isWaiveMedicalReq = item.tpaWaiveOffType === "Waive Medical Req.";
      return {
        ...item,
        proposalCreationStartDate: isWaiveMedicalReq
          ? item.proposalCreationStartDate
          : "",
        proposalCreationEndDate: isWaiveMedicalReq
          ? item.proposalCreationEndDate
          : "",
      };
    });
  };

  const renderSelectField = ({
    id,
    label,
    value,
    onChange,
    disabled = false,
    children,
  }) => (
    <div className="tpa-medical-scheduling__field">
      <label className="tpa-medical-scheduling__label" htmlFor={id}>
        {label}
      </label>
      <div className="custom-select-container">
        <select
          className="tpa-medical-scheduling__select form-control custom-dropdown custom-select"
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
        >
          {children}
        </select>
      </div>
    </div>
  );

  return (
    <>
      <div className="proposal-dashboard tpa-medical-scheduling">
        <div className="proposal-dashboard__header tpa-medical-scheduling__header">
          <h2 className="proposal-dashboard__title">TPA Medical Scheduling</h2>
          <p className="proposal-dashboard__subtitle">
            Configure waive-off rules and manage entries
          </p>
        </div>

        <div className="tpa-medical-scheduling__form-panel">
          <div className="tpa-medical-scheduling__compact-grid">
            {renderSelectField({
              id: "tpaWaiveOffType",
              label: "Waive off type",
              value: mainData?.waiveOffOption,
              onChange: (event) => handleChange(event, "waiveOffOption"),
              children: (
                <>
                  {options.length && (
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                  )}
                  {options.map((option) => (
                    <option key={option.key} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
            {renderSelectField({
              id: "tpaWaiveOffFor",
              label: "Waive off for",
              value: mainData.waivedRadio,
              onChange: (event) => handleChange(event, "waivedRadio"),
              children: (
                <>
                  {radios.length && (
                    <option value="" disabled hidden>
                      -- select --
                    </option>
                  )}
                  {radios.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
            {renderSelectField({
              id: "source",
              label: "Source",
              value: mainData.sourceValue,
              onChange: (e) => handleChange(e, "sourceValue"),
              children: (
                <>
                  <option value="" disabled>
                    -- select --
                  </option>
                  <option value="ALL_VALUES">All</option>
                  {sourceList?.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
            {renderSelectField({
              id: "channel",
              label: "Channel",
              value: mainData.channelValue,
              onChange: (e) => handleChange(e, "channelValue"),
              disabled:
                !mainData.sourceValue ||
                mainData.sourceValue === "ALL_VALUES",
              children: (
                <>
                  <option value="" disabled>
                    -- select --
                  </option>
                  <option value="ALL_VALUES">All</option>
                  {channelList?.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
            {renderSelectField({
              id: "subPartner",
              label: "Sub Channel",
              value: mainData.subPartnerValue,
              onChange: (e) => handleChange(e, "subPartnerValue"),
              disabled:
                !mainData.sourceValue ||
                mainData.sourceValue === "ALL_VALUES" ||
                !mainData.channelValue ||
                mainData.channelValue === "ALL_VALUES",
              children: (
                <>
                  <option value="" disabled>
                    -- select --
                  </option>
                  <option value="ALL_VALUES">All</option>
                  {subPartnerList?.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
            {renderSelectField({
              id: "partner",
              label: "Partner",
              value: mainData.partnerValue,
              onChange: (e) => handleChange(e, "partnerValue"),
              disabled:
                !mainData.sourceValue ||
                mainData.sourceValue === "ALL_VALUES" ||
                !mainData.channelValue ||
                mainData.channelValue === "ALL_VALUES" ||
                !mainData.subPartnerValue ||
                mainData.subPartnerValue === "ALL_VALUES" ||
                partnerList.length === 0,
              children: (
                <>
                  <option value="" disabled>
                    -- select --
                  </option>
                  <option value="ALL_VALUES">All</option>
                  {partnerList?.map((option) => (
                    <option key={option.id} value={option.text}>
                      {option.text}
                    </option>
                  ))}
                </>
              ),
            })}
          </div>

          {mainData.waiveOffOption === "Waive off Medical Requirement" && (
            <div className="tpa-medical-scheduling__compact-grid tpa-medical-scheduling__compact-grid--schedule">
              {renderSelectField({
                id: "tpaProductName",
                label: "Product name",
                value: mainData?.productName,
                onChange: (event) => handleChange(event, "productName"),
                children: (
                  <>
                    {productName.length && (
                      <option value="" disabled hidden>
                        -- select --
                      </option>
                    )}
                    {productName.map((option) => (
                      <option key={option.id} value={option.text}>
                        {option.text}
                      </option>
                    ))}
                  </>
                ),
              })}
              <FreezeDates
                compact
                tpaData={tpaData}
                handleChange={handleDateChange}
                startDate={mainData.startDate}
                startTime={mainData.startTime}
                endDate={mainData.endDate}
                endTime={mainData.endTime}
              />
            </div>
          )}

          <div className="tpa-medical-scheduling__actions">
            <button
              type="button"
              className="tpa-medical-scheduling__btn tpa-medical-scheduling__btn--primary"
              onClick={showCancelBtn ? updateTPAData : finalSubmit}
              disabled={
                showCancelBtn
                  ? false
                  : !mainData?.waiveOffOption || !mainData?.waivedRadio
              }
            >
              {showCancelBtn ? "Update" : "Submit"}
            </button>
            {showCancelBtn && (
              <button
                type="button"
                className="tpa-medical-scheduling__btn tpa-medical-scheduling__btn--secondary"
                onClick={cancelHandler}
              >
                Cancel
              </button>
            )}
          </div>
        </div>

        <div className="proposal-dashboard__table-section">
          <DataTable
            cellHeaders={[
              "Id",
              "Channel Name",
              "Sub Channel Name",
              "Cab Partner Name",
              "Product Name",
              "Proposal Creation StartDate",
              "Proposal Creation EndDate",
              "Waived Off By",
              "Audit",
              "TPA WaiveOff Type",
              "TPA WaiveOff For Proposer",
              "TPA WaiveOff For Insured",
              "TPA WaiveOff For Both",
              "",
            ]}
            keys={[
              "id",
              "channelName",
              "subChannelName",
              "cabPartnerName",
              "productName",
              "proposalCreationStartDate",
              "proposalCreationEndDate",
              "waivedOffBy",
              "audit",
              "tpaWaiveOffType",
              "tpaWaiveOffForProposer",
              "tpaWaiveOffForInsured",
              "tpaWaiveOffForBoth",
              "FreezecustomButtons",
            ]}
            data={getFormattedTpaData(tpaData).sort((a, b) => b.id - a.id)}
            fileName="Freeze Data"
            addSerialNo={true}
            onCustomButtonClick={(item) => {
              handleUpdateChange(item);
            }}
            onCustomDeletButtonClick={(item) => {
              setModalData(item);
              setshowDeleteModal(true);
            }}
            convertValueToString={true}
            showExcelDownload={true}
            PerPageApiData={false}
            paginationItems={data}
            alwaysShown={false}
          />
        </div>
      </div>

      {showDeleteModal && (
        <MobilePopUp
          onClose={() => {
            setshowDeleteModal(false);
          }}
        >
          <>
            <div>
              <div className="h3 freeze-data-delete-message1">
                Are you sure?
              </div>
              <div className="freeze-data-delete-message2">
                you won't to able revert this!
              </div>
            </div>
            <div className="Freeze-Delete-button-wrapper">
              <button
                className="delte-no-btn custom-button"
                onClick={() => setshowDeleteModal(false)}
              >
                Cancel
              </button>
              <button
                className="delte-yes-btn custom-button"
                onClick={() => deleteData(modalData)}
              >
                Yes, delete it!
              </button>
            </div>
          </>
          ;
        </MobilePopUp>
      )}

      {statusPanON && (
        <div className="tpa-medical-scheduling__alert-overlay">
          <span className="tpa-medical-scheduling__alert-backdrop" />
          <div className="tpa-medical-scheduling__alert-modal">
            <div className="tpa-medical-scheduling__alert-title">
              Waive Off Medicals (PAN India)
            </div>
            <p className="tpa-medical-scheduling__alert-text">
              Proposal Submission Switch tab is ON.
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default TPA_MedicalScheduling;
